module.exports = "files-shared"